/**
 * Business Dashboard Constants
 * Centralized configuration for the dashboard
 * Uses dark/black theme for business users
 */

// Business theme colors - dark/professional
export const BUSINESS_COLORS = {
  primary: '#1a1a1a',
  accent: '#f59e0b', // Amber accent
  gradient: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
};

export const STAT_CARD_CONFIG = [
  {
    key: 'totalShipments',
    titleKey: 'businessDashboard.stats.totalShipments',
    valueKey: 'totalParcels',
    icon: 'LocalShipping',
    gradient: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
    bgColor: 'rgba(26, 26, 26, 0.08)',
    trend: '+12.5%',
    trendUp: true,
    subtitleKey: 'businessDashboard.stats.allTime',
  },
  {
    key: 'activeDeliveries',
    titleKey: 'businessDashboard.stats.activeDeliveries',
    valueKey: 'activeParcels',
    icon: 'Bolt',
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    bgColor: 'rgba(245, 158, 11, 0.08)',
    trend: '+8.2%',
    trendUp: true,
    subtitleKey: 'businessDashboard.stats.inTransit',
  },
  {
    key: 'monthlySpend',
    titleKey: 'businessDashboard.stats.monthlySpend',
    valueKey: 'totalSpend',
    icon: 'AttachMoney',
    gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    bgColor: 'rgba(5, 150, 105, 0.08)',
    trend: '-5.3%',
    trendUp: false,
    subtitleKey: 'businessDashboard.stats.thisMonth',
    format: 'currency',
  },
  {
    key: 'successRate',
    titleKey: 'businessDashboard.stats.successRate',
    valueKey: 'successRate',
    icon: 'EmojiEvents',
    gradient: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
    bgColor: 'rgba(59, 130, 246, 0.08)',
    trend: '+2.1%',
    trendUp: true,
    subtitleKey: 'businessDashboard.stats.deliveryRate',
    format: 'percentage',
  },
];

export const QUICK_ACTIONS = [
  {
    key: 'createShipment',
    titleKey: 'businessDashboard.actions.createShipment',
    subtitleKey: 'businessDashboard.actions.bookNewDelivery',
    icon: 'LocalShipping',
    route: '/booking',
    gradient: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
    iconBg: 'rgba(26, 26, 26, 0.12)',
  },
  {
    key: 'manageAddresses',
    titleKey: 'businessDashboard.actions.manageAddresses',
    subtitleKey: 'businessDashboard.actions.savedLocations',
    icon: 'LocationOn',
    route: '/saved-addresses',
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    iconBg: 'rgba(245, 158, 11, 0.12)',
  },
  {
    key: 'invoices',
    titleKey: 'businessDashboard.actions.invoices',
    subtitleKey: 'businessDashboard.actions.billingHistory',
    icon: 'Receipt',
    route: '/invoices',
    gradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
    iconBg: 'rgba(16, 185, 129, 0.12)',
  },
  {
    key: 'pricingEstimator',
    titleKey: 'businessDashboard.actions.pricingEstimator',
    subtitleKey: 'businessDashboard.actions.getQuote',
    icon: 'Calculate',
    route: '/estimate',
    gradient: 'linear-gradient(135deg, #6b7280 0%, #9ca3af 100%)',
    iconBg: 'rgba(107, 114, 128, 0.12)',
  },
  {
    key: 'bulkBooking',
    titleKey: 'businessDashboard.actions.bulkBooking',
    subtitleKey: 'businessDashboard.actions.shipMultiple',
    icon: 'Inventory2',
    route: '/bulk-booking',
    gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
    iconBg: 'rgba(124, 58, 237, 0.12)',
  },
];

export const STATUS_COLOR_MAP = {
  delivered: 'success',
  completed: 'success',
  success: 'success',
  transit: 'info',
  pickup: 'info',
  'in transit': 'info',
  in_transit: 'info',
  assigned: 'info',
  picked_up: 'info',
  pending: 'warning',
  fail: 'error',
  failed: 'error',
  cancel: 'error',
  cancelled: 'error',
  default: 'default',
};
